import React from "react";

export const getLeagueStats = async ({ baseUrl, sport, dataId, headers }) => {
  const endpoints = [
    `${baseUrl}/${sport}/stat/league/${dataId}/overview`,
    `${baseUrl}/${sport}/league/${dataId}/top-scorers`,
    `${baseUrl}/${sport}/league/${dataId}/top-assists`,
  ];

  const responses = await Promise.all(
    endpoints.map(async (endpoint) => {
      const res = await fetch(endpoint, { next: { revalidate: 0 }, headers });
      if (!res.ok) throw new Error(`Failed to fetch ${endpoint}`);
      return res.json();
    })
  );

  return {
    overview: responses[0],
    topScorers: responses[1],
    topAssists: responses[2],
  };
};
